<template>
    <main class="main-content" id="main-content">
        <div class="container">
          <section class="section">
            <page-header>
                <template v-slot:pageTitle>
                  {{$t("booking")}}
                </template>
            </page-header>
            <div class="section__body">
              <div class="reservation box bg-white">
                <form name="reservation-select-form" method="post">
                  <div class="reservation__title section__title section__title_style3">Выберите услугу для бронирования</div>
                  <div class="reservation__form">
                    <div class="row">
                      <div class="col-12 col-md-auto">
                        <div class="checkbox">
                          <label class="checkbox__label" for="reservation-internet">
                            <input class="checkbox__hidden" type="checkbox" id="reservation-internet" name="reservation-internet" value="Интернет" checked><span class="checkbox__custom svg-icon" aria-hidden="true">
                              <svg role="img" width="10" height="10">
                                <use xlink:href="#svg-icon-check"></use>
                              </svg></span><span class="checkbox__title">Интернет</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-12 col-md-auto">
                        <div class="checkbox">
                          <label class="checkbox__label" for="reservation-tv">
                            <input class="checkbox__hidden" type="checkbox" id="reservation-tv" name="reservation-tv" value="Телевидение"><span class="checkbox__custom svg-icon" aria-hidden="true">
                              <svg role="img" width="10" height="10">
                                <use xlink:href="#svg-icon-check"></use>
                              </svg></span><span class="checkbox__title">Телевидение</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-12 col-md-auto">
                        <div class="checkbox">
                          <label class="checkbox__label" for="reservation-phone">
                            <input class="checkbox__hidden" type="checkbox" id="reservation-phone" name="reservation-phone" value="Телефония"><span class="checkbox__custom svg-icon" aria-hidden="true">
                              <svg role="img" width="10" height="10">
                                <use xlink:href="#svg-icon-check"></use>
                              </svg></span><span class="checkbox__title">Телефония</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-12 col-md-auto">
                        <div class="checkbox">
                          <label class="checkbox__label" for="reservation-packages">
                            <input class="checkbox__hidden" type="checkbox" id="reservation-packages" name="reservation-packages" value="Пакетные услуги"><span class="checkbox__custom svg-icon" aria-hidden="true">
                              <svg role="img" width="10" height="10">
                                <use xlink:href="#svg-icon-check"></use>
                              </svg></span><span class="checkbox__title">Пакетные услуги</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul class="list list_unstyled reservation__list">
                    <li class="list__item">
                      <!-- ссылки на pdf- или docx-файл--><a class="link" href="javascript: void(0);" download>Максимальные сроки бронирования услуг</a>
                    </li>
                    <li class="list__item">
                      <!-- ссылки на pdf- или docx-файл--><a class="link" href="javascript: void(0);" download>Ежемесячная плата за бронирование</a>
                    </li>
                  </ul>
                  <div class="btn-group">
                    <div class="row">
                      <div class="col-12 col-sm-auto">
                        <button class="btn btn_default btn_green js-reservation-select" type="submit">Далее</button>
                      </div>
                      <div class="col-12 col-sm-auto order-sm-first"><router-link class="btn btn_default btn_white" to="/">На главную</router-link></div>
                    </div>
                  </div>
                </form>
                <div class="reservation__descr reservation__descr_note section__description color-gray">
                  <p>Услуга «Бронирование» предоставляется для телефония на срок до 6-ти месяцев, один раз в год.</p>
                  <p>Услуга «Бронирование» предоставляется для интернета на срок до 3-х месяцев, один раз в год.</p>
                  <p>Услуга «Бронирование» предоставляется для телевидения на срок до 4-х месяцев, один раз в год.</p>
                  <p>Услуга «Бронирование» предоставляется для пакетных услуг (2в1, 3в1) на срок до 4-х месяцев, один раз в год.</p>
                </div>
              </div>
            </div>
          </section>
        </div>
    </main>
</template>
<script>
import PageHeader from "@/components/PageHeader";
// import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  components: {
    PageHeader
  }
}
</script>
<style scoped>

</style>